import { ItemDataRow } from '@warebee/shared/dataset-queries';
import {
  HeatmapMetricDescriptor,
  HeatmapMetricDescriptorBase,
} from '../../common/heatmap.types';

export const itemSetMetrics = [
  //Items
  'sku',
  'consignee',
  'consigneeSku',
  'skuGroup',
  'subGroup',
  'transportClass',
  'stockCategory',
  'storageClass',
  'pollutionClass',
  // UOM
  'stockUom',
  'uom',
  'uomWeight',
  'uomWeightPow',
  'uomVolume',
  'uomVolumePow',
  'uomCapacity',
  'uomDensity',
  'uomProportionality',
  'uomMaxStack',
] as const;

export type ItemSetMetric = (typeof itemSetMetrics)[number];

export type ItemSetMetricDescriptorBase = HeatmapMetricDescriptorBase<
  ItemSetMetric,
  ItemSetMetricDataRow
>;

export type ItemSetMetricDescriptor = HeatmapMetricDescriptor<
  ItemSetMetric,
  ItemSetMetricDataRow
>;

export type ItemSetMetricDataRow = ItemDataRow;
